<template>
  <div v-if="featuresList && featuresList.length" class="app-features-list">
    <div
      v-for="feature in featuresList"
      :key="feature.title"
      class="row"
      :class="{ '--left': !feature.imageRight }"
      data-aos="fade-up"
    >
      <div
        v-if="feature.decorationCylinder && feature.decorationCylinder === 'left'"
        class="decoration-cylinder-horizontal --left"
      ></div>

      <div
        v-if="feature.decorationCylinder && feature.decorationCylinder === 'right'"
        class="decoration-cylinder-horizontal --right"
      ></div>

      <div class="content">
        <img
          v-if="feature.icon && feature.icon.mediaItemUrl"
          class="icon"
          v-lazy-load :data-src="feature.icon.mediaItemUrl"
          width="1920"
          height="1080"
        />
        <p class="name">{{ feature.title }}</p>
        <p class="desc">{{ feature.content }}</p>
      </div>

      <div v-if="feature.image && feature.image.srcSet" class="media" :class="{ '--web': isWeb }">
        <AppImage
          class="img"
          :image="feature.image.srcSet"
          :alt="feature.image.altText"
          :blurred-preview="feature.image.imageBlur"
        />
        <img
          v-if="feature.extraImageRight && feature.extraImageRight.mediaItemUrl"
          class="extra-img --right"
          width="1920"
          height="1080"
          v-lazy-load :data-src="feature.extraImageRight.mediaItemUrl"
        />
        <div v-if="feature.extraImageTopLeft" class="fake-toolip-container">
          <div class="fake-tooltip">
            <div class="area">55,1 m<sup>2</sup></div>
            <div class="close">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
            <div class="like">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-heart"
              >
                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                ></path>
              </svg>
            </div>
            <img
              v-if="feature.extraImageTopLeft && feature.extraImageTopLeft.mediaItemUrl"
              width="1920"
              height="1080"
              class="image"
              v-lazy-load :data-src="feature.extraImageTopLeft.mediaItemUrl"
            />
            <div class="columns">
              <div class="column">2<span>rooms</span></div>
              <div class="column">8<span>floor</span></div>
              <div class="column">811<span>number</span></div>
            </div>
            <div class="btn-tooltip">
              <svg class="icon" viewBox="0 0 548 548">
                <polygon
                  points="177.9,51.9 177.9,87.9 297.5,87.9 297.5,148.1 333.5,148.1 333.5,87.9 493.2,87.9 493.2,254.2 333.5,254.2 
                          333.5,205.8 297.5,205.8 297.5,338.4 333.5,338.4 333.5,290.1 493.2,290.1 493.2,460 333.5,460 333.5,398.3 297.5,398.3 297.5,460 
                          54.8,460 54.8,241.4 232.6,241.4 232.6,205.3 54.8,205.3 54.8,87.9 101.6,87.9 101.6,51.9 18.7,51.9 18.7,496.1 529.3,496.1 
                          529.3,51.9"
                /></svg
              >Preview
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFeaturesList',
  components: { AppImage: () => import('@/components/common/AppImage') },
  props: {
    featuresList: {
      type: Array,
      default: () => [],
    },
    isWeb: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/common/AppFeaturesList';
</style>
